import React from 'react'
import PropTypes from 'prop-types'

import { Vegan, Vegetarian, Meat, Fish, Pastries } from '@aok/icon-functional'

import { DietType } from './dietTypes'

const DietIcon = ({ diet, className }) => {
  if (!diet) return null

  let Icon

  switch (diet) {
    case DietType.VEGAN:
      Icon = Vegan
      break

    case DietType.VEGETARISCH:
      Icon = Vegetarian
      break

    case DietType.MIT_FLEISCH:
      Icon = Meat
      break

    case DietType.MIT_FISCH:
      Icon = Fish
      break

    case DietType.GEBÄCK:
      Icon = Pastries
      break

    default:
      return null
  }

  return <Icon className={className} />
}

DietIcon.propTypes = {
  diet: PropTypes.oneOf(Object.values(DietType)),
  className: PropTypes.string,
}

export default DietIcon
